import _ from 'lodash';

import getReduxInitial from '../helpers/redux_initial';

const pcDefaults = {};
const pcInitial = _.assign({}, pcDefaults, getReduxInitial('productCompatibility', {}));
export const productsCompatibilityReducer = (state = pcInitial, _action) => state;
